/*
 * @Author: Wangchaoke
 * @Date: 2020-03-03 10:01:32
 * @LastEditTime: 2021-01-06 09:01:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xingmahui_front/src/utils/axiosApi/growApi.js
 */
import Http from "./../http";

export default {
  // 获取
  growthrecord(params, callback) {
    Http.get("/growthrecord/list", params, res => {
      callback(res);
    })
  },
  // 查询成长记录
  getGrowInfo(urlParams, params, callback) {
    Http.post("/growthrecord/queryinfo", urlParams, params, res => {
      callback(res);
    })
  },
  // 添加成长记录
  addGrowInfo(urlParams, params, callback) {
    Http.post("/growthrecord/addinfo", urlParams, params, res => {
      callback(res);
    })
  },
  // 获取宝宝信息
  getBabyInfo(params, callback) {
    Http.get("/starMom/getBaby", params, res => {
      callback(res)
    },err => {}, "member")
  },
  // 查询宝宝是否孕期填写过成长记录
  getBabyPregnRecord(params, callback) {
    Http.get("/growthrecord/queryRecordBeforeBorn", params, res => {
      callback(res)
    })
  },

}